<div class="my-3 my-md-5">
    <div class="container">
    	<div class="page-header">
            <h1 class="page-title">
                <span>Adding Lead</span>
                <!-- <span *ngIf="LeadId">Update Lead</span> -->
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="leadForm" (submit)="saveLead()">
            	<div class="card-body">
		            <div class="container-fluid p-3">
		                <div class="form-group">
		                    <div class="row">
		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Lead Name *</label>
		                                <input class="form-control" formControlName="lead_name" placeholder="Lead Name" />
		                                <div *ngIf="submitted && f.lead_name.errors" class="invalid-feedback">
                                        	<div *ngIf="f.lead_name.errors.required">Lead Name is required</div>
                                    	</div>
		                            </div>
		                        </div>
		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Lead Mobile *</label>
		                                <input class="form-control" (blur) = 'checkMobile()' formControlName="mobile" placeholder="Lead Mobile" />
		                                <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
	                                        <div *ngIf="f.mobile.errors.required">Lead Mobile is required</div>
	                                        <div *ngIf="!f.mobile.valid && f.mobile.value">Invalid Mobile number format</div>
                                    </div>
		                            </div>
		                        </div>
		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Lead City *</label>
		                                <mat-select placeholder="Select City" formControlName="city_id" (click)="setSearchValue('city')" (selectionChange)="getCircleOfCity($event.value)">
										<input class="mySearchInput"
										#citySearch focused="'true'" type="text"
										(keyup)="searchOnSelect($event.target.value, 'city')"
										(keydown)="$event.stopPropagation()" autocomplete="off"
										placeholder="Search"
										id="citySearch">
		                                    <mat-option>Select City</mat-option>
		                                    <mat-option [value]="city.city_id" *ngFor="let city of cities">{{city.name}}</mat-option>
		                                </mat-select>
		                                <div *ngIf="submitted && f.city_id.errors" class="invalid-feedback">
                                        	<div *ngIf="f.city_id.errors.required">Circle is required</div>
                                    	</div>
		                            </div>
		                        </div>
		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Treatment *</label>
		                                <mat-select placeholder="Select Treatment" formControlName="treatment_id" (click)="setSearchValue('treatment')">
											<input class="mySearchInput"
											#treatmentSearch focused="'true'" type="text"
											(keyup)="searchOnSelect($event.target.value, 'treatment')"
											(keydown)="$event.stopPropagation()" autocomplete="off"
											placeholder="Search"
											id="treatmentSearch">
		                                    <mat-option  [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
		                                </mat-select>
		                                <div *ngIf="submitted && f.treatment_id.errors" class="invalid-feedback">
                                        	<div *ngIf="f.treatment_id.errors.required">Treatment is required</div>
                                    	</div>
		                            </div>
		                        </div>
		                        
		                    </div> 
		                </div>

		                <div class="form-group">
		                    <div class="row">
		                        <div class="col-sm-3" [ngStyle]="{'display':lead_source_style}">
		                            <div class="form-group">
		                                <label class="form-label">Lead Source *</label>
		                                <mat-select placeholder="Select Lead Source" formControlName="lead_source" (selectionChange)="AddRemoveValidation($event)">
											<mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
		                                </mat-select>
		                                <div *ngIf="submitted && f.lead_source.errors" class="invalid-feedback">
                                        	<div *ngIf="f.lead_source.errors.required">Lead Source is required</div>
                                    	</div>
		                            </div>
		                        </div>
								<div class="col-sm-3" *ngIf="f.lead_source.value == 77">
									<!--Lead Source(Offline=77)-->
								    <div class="form-group">
								        <label class="form-label">Affiliate Users</label>
								        <mat-select placeholder="Select Affiliate User" formControlName="affiliate_id" (click)="setSearchValue('affiliate_user')">
											<input class="mySearchInput"
											#affiliate_userSearch focused="'true'" type="text"
											(keyup)="searchOnSelect($event.target.value, 'affiliate_user')"
											(keydown)="$event.stopPropagation()" autocomplete="off"
											placeholder="Search"
											id="affiliate_userSearch">
								            <mat-option [value]="aff_user.affiliate_id" *ngFor="let aff_user of affiliateUsers">{{aff_user.name}}({{aff_user.affiliate_id}})</mat-option>
								        </mat-select>
								    </div>
								</div>
								<div class="col-sm-3" *ngIf="f.lead_source.value == 7">
		                            <div class="form-group">
		                                <label class="form-label">Referral Type</label>
		                                <mat-select  formControlName="referral_type" placeholder="Select Referral Type">
		                                    <mat-option value="{{sub_source.id}}" *ngFor="let sub_source of leadSubCat">{{sub_source.name}}</mat-option>
		                                    <!-- <mat-option value="1">Doctor Refferal</mat-option>
		                                    <mat-option value="2">Employee Refferal</mat-option>
		                                    <mat-option value="3">Others Refferal</mat-option>
											<mat-option value="4">Patient Refferal</mat-option>
											<mat-option value="5">PX Refferal</mat-option>
											<mat-option value="6">Diagnostic Refferal</mat-option>
											<mat-option value="7">Lab Refferal</mat-option>
											<mat-option value="8">Phlebotomist Refferal</mat-option>
											<mat-option value="9">City Team</mat-option> -->
		                                 </mat-select>
										 <div *ngIf="submitted && f.referral_type.errors" class="invalid-feedback">
											<div *ngIf="f.referral_type.errors.required">Referral Type is required</div>
										</div>
		                            </div>
									
		                        </div>
								<div class="col-sm-3" *ngIf="f.lead_source.value == 7">
		                            <div class="form-group">
		                                <label class="form-label">Referral Person Name *</label>
		                                <input class="form-control" formControlName="referral_name" placeholder="Referral Person Name" />
		                                <div *ngIf="submitted && f.referral_name.errors" class="invalid-feedback">
                                        	<div *ngIf="f.referral_name.errors.required">Referral Person Name is required</div>
                                    	</div>
		                            </div>
		                        </div>
		                        <div class="col-sm-3" *ngIf="f.lead_source.value == 7"> 
		                            <div class="form-group">
		                                <label class="form-label">Referral Person Mobile *</label>
		                                <input class="form-control" formControlName="referral_mobile" placeholder="Referral Person Mobile" (keyup)="checkModelVal()"/>
		                                <div *ngIf="submitted && f.referral_mobile.errors" class="invalid-feedback">
	                                        <div *ngIf="f.referral_mobile.errors.required">Referral Person Mobile is required</div>
	                                        <div *ngIf="!f.referral_mobile.valid && f.referral_mobile.value">Invalid Mobile number format</div>
										</div>
										<div class="invalid-feedback"><span *ngIf="checkModelVal() && f.referral_mobile.value">Mobile Number should be different</span></div>
		                            </div>
		                        </div>
								
								<div class="col-sm-3" *ngIf="f.lead_source.value == 34 || f.lead_source.value == 89">
		                            <div class="form-group">
		                                <label class="form-label">Doctor</label>
		                                <mat-select  formControlName="doctor" placeholder="Select Doctor" (click)="setSearchValue('doctor')">
		                                    <input class="mySearchInput"
										#doctor_Search focused="'true'" type="text"
										(keyup)="searchOnSelect($event.target.value, 'doctor')"
										(keydown)="$event.stopPropagation()" autocomplete="off"
										placeholder="Search"
										id="doctor_Search">
		                                    <mat-option [value]="doctor_list.id" *ngFor="let doctor_list of doctorList">{{doctor_list.name}}</mat-option>
		                                </mat-select>
										<div *ngIf="myrole!='1' || myrole!='4'">
                                        	<a href="/create-doctor" target="_blank">+ Add Doctor</a>
                                    	</div>
		                            </div>
		                        </div>

								<div class="col-sm-3" *ngIf="f.lead_source.value == 34 || f.lead_source.value == 35 || f.lead_source.value == 89">
		                            <div class="form-group">
		                                <label class="form-label">MD Spok</label>
		                                <mat-select  formControlName="md_spok" placeholder="Select MD Spok">
		                                    <mat-option [value]="mdspok_user.id" *ngFor="let mdspok_user of mdSpokUsers">{{mdspok_user.name}}</mat-option>
		                                </mat-select>
		                            </div>
		                        </div>

		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Follow Up Date</label>
		                                <mat-form-field class="example-full-width" appearance="fill">
		                                    <mat-label>Choose a date</mat-label>
		                                    <input matInput  formControlName="followup_date" [matDatepicker]="picker1">
		                                    <mat-datepicker-toggle matSuffix [for]="picker1">
		                                    </mat-datepicker-toggle>
		                                    <mat-datepicker #picker1></mat-datepicker>
		                                </mat-form-field>
		                            </div>
		                        </div>
		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Lead Status *</label>
		                                <mat-select class="readOnly" placeholder="Select Lead Status" formControlName="lead_status_id" (click)="setSearchValue('lead_status')">
										<input class="mySearchInput"
										#lead_status_Search focused="'true'" type="text"
										(keyup)="searchOnSelect($event.target.value, 'lead_status')"
										(keydown)="$event.stopPropagation()" autocomplete="off"
										placeholder="Search"
										id="lead_status_Search">
		                                    <mat-option [value]="lead_status.id" *ngFor="let lead_status of leadStatus">{{lead_status.name}}</mat-option>
		                                </mat-select>
		                                <div *ngIf="submitted && f.lead_status_id.errors" class="invalid-feedback">
                                        	<div *ngIf="f.lead_status_id.errors.required">Lead Status is required</div>
                                    	</div>
		                            </div>
		                        </div>
		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Payment Mode</label>
		                                <mat-select  formControlName="payment_mode" placeholder="Select Payment Mode">
		                                    <mat-option>Select</mat-option>
		                                    <mat-option value="Cash">Cash</mat-option>
		                                    <mat-option value="Cashless">Cashless</mat-option>
		                                    <mat-option value="Reimbursement">Reimbursement</mat-option>
		                                    <mat-option value="EMI">EMI</mat-option>
		                                </mat-select>
		                            </div>
		                        </div>
							<!-- </div> 
		                </div>

		                <div class="form-group">
		                    <div class="row"> -->
		                        <div class="col-sm-3" style="display:none">
								    <div class="form-group">
								        <label class="form-label">Circle *</label>
								        <mat-select placeholder="Select Circle" formControlName="circle_id" (click)="setSearchValue('circle')">
											<input class="mySearchInput"
											#circleSearch focused="'true'" type="text"
											(keyup)="searchOnSelect($event.target.value, 'circle')"
											(keydown)="$event.stopPropagation()" autocomplete="off"
											placeholder="Search"
											id="circleSearch">
								            <mat-option [value]="circle.id" *ngFor="let circle of circles">{{circle.name}}</mat-option>
								        </mat-select>
								        <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
								        	<div *ngIf="f.circle_id.errors.required">Circle is required</div>
								    	</div>
								    </div>
								</div>
								<div class="col-sm-3" [ngStyle]="{'display':lead_owner_style}">
		                            <div class="form-group">
		                                <label class="form-label">Lead Owner *</label>
		                                <mat-select placeholder="Select Lead Owner" [disabled]="lead_bd" formControlName="user_id" (click)="setSearchValue('lead_owner')">
											<input class="mySearchInput"
											#ownerSearch focused="'true'" type="text"
											(keyup)="searchOnSelect($event.target.value, 'lead_owner')"
											(keydown)="$event.stopPropagation()" autocomplete="off"
											placeholder="Search"
											id="ownerSearch">
		                                    <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
		                                </mat-select>
		                                <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                                        	<div *ngIf="f.user_id.errors.required">Lead Owner is required</div>
                                    	</div>
		                            </div>
		                        </div>
		                        <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Description</label>
		                                <textarea class="form-control" formControlName="description"></textarea>
		                            </div>
		                        </div>
		                       
		                    </div> 
		                </div>
		            </div>
				</div>
				<div class="card-footer">
                    <button  type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> 
                        <span>Create Lead</span>
                        <!-- <span *ngIf="LeadId">Update Lead</span>    -->
                          
                    </button>
                </div>
	        </form>
        </div>
    </div>
</div>

<!-- Show mobile number allready exist modal-->
<div class="modal fade" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Mobile Number Already Exists!</h4>
          <button type="button" class="close" (click)="hideModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <div class="col-sm-12" style="overflow: scroll">
						  <table class="table">
							<thead>
							  <tr>
								<th scope="col">#</th>
								<th scope="col">Lead ID</th>
								<th scope="col">Name</th>
								<th scope="col">Treatment</th>
								<th scope="col">Mobile</th>
								<th scope="col">Source</th>
								<th scope="col">Lead Status</th>
								<th scope="col">Bd Name</th>
								<th scope="col">Date</th>
							  </tr>
							</thead>
							<tbody>
							  <tr *ngFor="let data of checkLeadData;let index = index;">
								<th scope="row">{{index+1}}</th>
								<td> {{data.id}}</td>
								<td>{{data.patient_name}}</td>
								<td>{{data.treatment_name}}</td>
								<td>{{data.mobile}}</td>
								<td>{{data.lead_source}}</td>
								<td>{{data.lead_status_name}}</td>
								<td>{{data.bd_name}}</td>
								<td>{{data.created_at*1000|date:'d MMM, yyyy'}}</td>
							  </tr>
							</tbody>
						  </table>
                      </div>
                  </div>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModal()">Close</button>
        </div>
      </div>
    </div>
</div>
